import * as React from 'react';
import './horizontal-divider.css';

export default class HorizontalDivider extends React.PureComponent<{}, {}> {
  render(): JSX.Element {
    return <div className="horizontal-divider" />;
  }
}
